<template>
    <div v-infinite-scroll="loadMore" infinite-scroll-distance="25">
        <slot :listPortion="listPortion" />
    </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'

const defaultScrollLimit = 15

// Requires a container with a bounded height (flex, etc.)
export default {
    name: 'InfiniteScroller',
    directives: {
        infiniteScroll,
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        ignoreUpdates: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scrollLimit: defaultScrollLimit,
            scrollStep: defaultScrollLimit,
        }
    },
    computed: {
        listPortion() {
            return this.list.slice(0, this.scrollLimit)
        },
    },
    watch: {
        list: {
            immediate: true,
            handler() {
                if (this.ignoreUpdates) {
                    return
                }
                this.scrollLimit = defaultScrollLimit
                this.$nextTick(this.loadUntilScrollable)
            },
        },
    },
    methods: {
        loadMore() {
            if (this.scrollLimit < this.list.length) {
                this.scrollLimit += this.scrollStep
            }
        },
        loadUntilScrollable() {
            if (
                this.scrollLimit < this.list.length &&
                this.$el.scrollHeight <= this.$el.clientHeight
            ) {
                this.scrollLimit += this.scrollStep
                this.$nextTick(this.loadUntilScrollable)
            }
        },
    },
}
</script>
